import { ZOHO_SYNC_CONFIG } from "../../constant";
import StatusChip from "../StatusChip/StatusChip";

const ZohoSyncStatus = ({ status }) => {
  const config = ZOHO_SYNC_CONFIG[status];

  if (!config) {
    return null;
  }

  return <StatusChip config={config} />;
};

export default ZohoSyncStatus;
